import React, { ReactNode } from 'react';
import Button from '@mui/material/Button';
import Tip from './Tip';

type SecondaryButtonProps = {
  id: string;
  tip?: string;
  children: ReactNode;
  [key: string]: any; // Allow additional props to be passed to the Button component
};

export default function SecondaryButton({ id, tip = '', children, ...rest }: SecondaryButtonProps) {
  const button = (
    <Button id={id} variant="contained" color="secondary" {...rest}>
      {children}
    </Button>
  );

  if (tip) {
    return (
      <Tip
        id={`${id}-tooltip`}
        title={tip}
        sx={{
          '&:last-child': {
            marginRight: 0,
          },
        }}
      >
        {button}
      </Tip>
    );
  }

  return button;
}
